function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NepalFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.61589 12.3201L15.4325 20.5H0.5V3.84227L14.5392 11.5H9H7.93248L8.61589 12.3201Z",
    fill: "#C51918",
    stroke: "#4857A1"
  }), /*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2199",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "17",
    height: "18",
    children: /*#__PURE__*/_jsx("path", {
      d: "M8.61589 12.3201L15.4325 20.5H0.5V3.84227L14.5392 11.5H9H7.93248L8.61589 12.3201Z",
      fill: "white",
      stroke: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2199)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.37222 18.0077L3.45335 19.2002L3.41093 17.6953L1.96658 18.12L2.81682 16.8776L1.39868 16.3722L2.81682 15.8668L1.96658 14.6244L3.41093 15.0491L3.45335 13.5442L4.37222 14.7368L5.2911 13.5442L5.33351 15.0491L6.77787 14.6244L5.92763 15.8668L7.34576 16.3722L5.92763 16.8776L6.77787 18.12L5.33351 17.6953L5.2911 19.2002L4.37222 18.0077Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.35004 9.1041L3.87016 9.72691L3.84801 8.94098L3.0937 9.16278L3.53774 8.51393L2.79712 8.25L3.53774 7.98607L3.0937 7.33722L3.84801 7.55902L3.87016 6.77309L4.35004 7.3959L4.82991 6.77309L4.85207 7.55902L5.60637 7.33722L5.16234 7.98607L5.90295 8.25L5.16234 8.51393L5.60637 9.16278L4.85207 8.94098L4.82991 9.72691L4.35004 9.1041Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.24954 8.92059C5.91928 8.92726 6.80953 7.98001 6.80953 7.98001C6.98565 9.06088 5.62588 9.78001 4.26582 9.78001C2.90575 9.78001 2.0823 8.79975 1.57498 7.98001C1.57498 7.98001 2.5798 8.91392 4.24954 8.92059Z",
      fill: "#F9FAFA"
    })]
  })]
}));
//# sourceMappingURL=Nepal.js.map